import { defineMessages } from 'react-intl';

export const messages: {
	validationErrorRatingRequired: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	validationErrorRatingRequired: {
		id: 'smart-create-feedback.emoji-rating-selector.validation.rating.required',
		defaultMessage: 'Please select a rating before submitting',
		description: 'Error message when rating is not selected',
	},
});
